<template>
  <div id="thanks">
    <Background />
    <h1 class="m-4 ">Cancelled</h1>
    <p>Either an error happened, or you chose not to finish the transaction. You can try again by clicking here:</p>
    <div class="m-4">
      <router-link class="btn-pill orange-pill" to="/">Retry</router-link>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>

import Background from './Background.vue'

export default {
  data () {
    return {
    }
  },
  components: {
    Background
  },
  props: {
    email: String
  }
}

</script>